import { mergeTailwindClasses } from '@xefi/x-react/utils';
import type { ReactNode } from 'react';

type PageContainerProps = {
   title?: ReactNode;
   classNames?: {
      base?: string;
      title?: string;
   };
   children: ReactNode;
};

export const PageContainer = ({
   title,
   classNames,
   children,
}: PageContainerProps) => {
   return (
      <div className={mergeTailwindClasses('px-8', classNames?.base)}>
         <h1
            className={mergeTailwindClasses(
               'mt-1 mb-4 text-xl font-bold',
               classNames?.title,
            )}
         >
            {title}
         </h1>
         {children}
      </div>
   );
};
